import { Injectable } from '@angular/core';

@Injectable()
export class Util {
  constructor() {}

  private readonly letterGradients: { [key: string]: string } = {
    'A': 'linear-gradient(135deg, #373b44 0%, #4286f4 100%)',
    'B': 'linear-gradient(135deg, #b92b27 0%, #1565c0 100%)',
    'C': 'linear-gradient(135deg, #1f4037 0%, #99f2c8 100%)',
    'D': 'linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%)',
    'E': 'linear-gradient(135deg, #009fff 0%, #ec2f4b 100%)',
    'F': 'linear-gradient(135deg, #da4453 0%, #89216b 100%)',
    'G': 'linear-gradient(135deg, #d66d75 0%, #e29587 100%)',
    'H': 'linear-gradient(135deg, #4568dc 0%, #b06ab3 100%)',
    'I': 'linear-gradient(135deg, #000046 0%, #1cb5e0 100%)',
    'J': 'linear-gradient(135deg, #283c86 0%, #45a247 100%)',
    'K': 'linear-gradient(135deg, #4e54c8 0%, #8f94fb 100%)',
    'L': 'linear-gradient(135deg, #0575e6 0%, #021b79 100%)',
    'M': 'linear-gradient(135deg, #3494e6 0%, #ec6ead 100%)',
    'N': 'linear-gradient(135deg, #2196f3 0%, #f44336 100%)',
    'O': 'linear-gradient(135deg, #4da0b0 0%, #d39d38 100%)',
    'P': 'linear-gradient(135deg, #8e0e00 0%, #1f1c18 100%)',
    'Q': 'linear-gradient(135deg, #360033 0%, #0b8793 100%)',
    'R': 'linear-gradient(135deg, #556270 0%, #ff6b6b 100%)',
    'S': 'linear-gradient(135deg, #4b6cb7 0%, #182848 100%)',
    'T': 'linear-gradient(135deg, #c04848 0%, #480048 100%)',
    'U': 'linear-gradient(135deg, #134e5e 0%, #71b280 100%)',
    'V': 'linear-gradient(135deg, #ff512f 0%, #f09819 100%)',
    'W': 'linear-gradient(135deg, #348f50 0%, #56b4d3 100%)',
    'X': 'linear-gradient(135deg, #314755 0%, #26a0da 100%)',
    'Y': 'linear-gradient(135deg, #536976 0%, #292e49 100%)',
    'Z': 'linear-gradient(135deg, #1488cc 0%, #2b32b2 100%)'
  };

  getAvatarGradient(initials: string): string {
    const firstInitial = initials.charAt(0).toUpperCase() || 'A';
    return this.letterGradients[firstInitial] || this.letterGradients['A'];
  }
  
}
